import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { SignArea } from './SignArea';
import { styles } from './styles';

interface FormProps {
  userLastName?: string;
  userFirstName?: string;
  userFiscalId?: string;
  userPhone?: string;
  userEmail?: string;
}

export const Form = ({
  userLastName,
  userFirstName,
  userFiscalId,
  userPhone,
  userEmail,
}: FormProps) => {
  return (
    <View>
      <View>
        <View style={styles.item}>
          <Text style={{ marginHorizontal: 8 }}> • </Text>
          <Text style={{ flex: 1 }}>
            La persona autorizada por la Empresa en carácter de “Administrador”
            para acceder al servicio es:{' '}
          </Text>
        </View>
        <View style={{ marginLeft: 28 }}>
          <Text style={styles.text}>
            <Text style={{ letterSpacing: 6 }}> • </Text>
            <Text>Apellido: {userLastName}</Text>
          </Text>
          <Text style={styles.text}>
            <Text style={{ letterSpacing: 6 }}> • </Text>
            <Text>Nombre: {userFirstName}</Text>
          </Text>
          <Text style={styles.text}>
            <Text style={{ letterSpacing: 6 }}> • </Text>
            <Text>CUIT/CUIL(*): {userFiscalId}</Text>
          </Text>
          <Text style={styles.text}>
            <Text style={{ letterSpacing: 6 }}> • </Text>
            <Text>Teléfono: {userPhone}</Text>
          </Text>
          <Text style={styles.text}>
            <Text style={{ letterSpacing: 6 }}> • </Text>
            <Text>Mail(**): {userEmail}</Text>
          </Text>
        </View>
      </View>
      <View style={{ paddingVertical: '24px' }}>
        <Text style={styles.text}>
          (*) La C.U.I.L de la persona, será el USUARIO de acceso al sistema.
        </Text>
        <Text style={styles.text}>
          (**) Dirección válida para confirmar el alta del usuario y futuras
          notificaciones.
        </Text>
      </View>
      <SignArea />
    </View>
  );
};

export default Form;
